import MaterialBreadcrumbs from "../../../../__snowpack__/pkg/@mui/material/Breadcrumbs.js";
import MaterialLink from "../../../../__snowpack__/pkg/@mui/material/Link.js";
import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import styled, {css} from "styled-components";
import {IconContainer} from "../../atoms/icon/icon.styles.js";
const basicBreadcrumbsCss = css(["", " ", "{", "}"], {
  display: "flex",
  alignItems: "center"
}, IconContainer, {
  marginRight: "0.25rem"
});
export const BreadcrumbsContainer = styled(MaterialBreadcrumbs).withConfig({
  displayName: "breadcrumbsstyles__BreadcrumbsContainer",
  componentId: "sc-1j01mrj-0"
})(["", ""], {
  display: "flex"
});
export const BreadcrumbsLinkContainer = styled(MaterialLink).withConfig({
  displayName: "breadcrumbsstyles__BreadcrumbsLinkContainer",
  componentId: "sc-1j01mrj-1"
})(["", " ", ""], basicBreadcrumbsCss, {
  cursor: "pointer"
});
export const BreadcrumbsTypographyContainer = styled(MaterialTypography).withConfig({
  displayName: "breadcrumbsstyles__BreadcrumbsTypographyContainer",
  componentId: "sc-1j01mrj-2"
})(["", ""], basicBreadcrumbsCss);
